import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=5b5a217f"
import script from "./CoachDetail.vue?vue&type=script&lang=ts"
export * from "./CoachDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports